export default __webpack_public_path__ + "img/b56914e1732ba174746bd5ae1226763c.png";